import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import moment from 'moment-timezone'

import type {CostAvoidanceMonthly} from '../api'
import {getCostAvoidanceMonthlyPath} from '../api/schedule.endpoints'

export const COST_AVOIDANCE_MONTHLY_QUERY_KEY = 'costAvoidanceMonthly'

export const costAvoidanceMonthlyQueryOptions = (
  plantId: string,
  fromYearMonth: string,
  toYearMonth: string
) => ({
  queryKey: [
    COST_AVOIDANCE_MONTHLY_QUERY_KEY,
    {plantCode: plantId, fromYearMonth, toYearMonth}
  ] as const,
  queryFn: async ({signal}: {signal?: AbortSignal}) => {
    const response = await ApiClient.axiosInstance.get<CostAvoidanceMonthly[]>(
      getCostAvoidanceMonthlyPath(plantId),
      {
        params: {from: fromYearMonth, to: toYearMonth},
        signal
      }
    )

    return response.data
  }
})

interface UseCostAvoidanceMonthlyQueryParams {
  plantId: string
  fromYearMonth: string
  toYearMonth: string
  range?: [fromYearMonth: string, toYearMonth: string]
  enabled?: boolean
  throwOnError?: boolean
}

export const useCostAvoidanceMonthlyQuery = ({
  plantId,
  fromYearMonth,
  toYearMonth,
  range,
  enabled = true,
  throwOnError = true
}: UseCostAvoidanceMonthlyQueryParams) => {
  return useQuery<CostAvoidanceMonthly[], AxiosError, CostAvoidanceMonthly[]>({
    ...costAvoidanceMonthlyQueryOptions(plantId, fromYearMonth, toYearMonth),
    enabled,
    throwOnError,
    ...(enabled ? {} : {gcTime: 0}),
    select: (costAvoidanceMonthly) =>
      costAvoidanceMonthly.filter((entry) =>
        range ? moment(entry.date).isBetween(moment(range[0]), moment(range[1]), 'day', '[)') : true
      )
  })
}
